<template>
  <div :class="wrapperClasses">
    <div role="tab" class="card-header" @click.prevent="toggle" :aria-expanded="isActive.toString()">
      <a
        data-toggle="collapse"
        data-parent="#accordion"
        :href="`#${itemId}`"
        :aria-controls="`content-${itemId}`"
      >
        <div class="collapse-item-header">
          <!-- Collapse Item Actions -->
          <div class="collapse-item-actions mr-3" v-if="this.$slots.actions"><slot name="actions"></slot></div>

          <!-- Collapse Item Title -->
          <div class="collapse-item-title"><slot name="title"> {{ title }} </slot></div>
        </div>

        <!-- arrow icon -->
        <i class="tim-icons icon-minimal-down"></i>
      </a>
    </div>
    <collapse-transition :duration="animationDuration">
      <div
        v-show="isActive"
        :id="`content-${itemId}`"
        role="tabpanel"
        :aria-labelledby="title"
        class="collapsed"
      >
        <div class="card-body"><slot></slot></div>
      </div>
    </collapse-transition>
  </div>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';

export default {
  name: 'collapse-item',
  components: {
    CollapseTransition
  },
  props: {
    title: {
      type: String,
      default: '',
      description: 'Collapse item title'
    },
    wrapperClasses: {
      type: [String, Object],
      default: 'card',
      description: 'wrapper css classes'
    },
    id: String,
    active: {
      type: Boolean,
      default: false
    },
    shouldClose: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    animationDuration: {
      default: 250
    },
    multipleActive: {
      default: false
    },
    addItem: {
      default: () => {}
    },
    removeItem: {
      default: () => {}
    },
    deactivateAll: {
      default: () => {}
    }
  },
  computed: {
    itemId() {
      return this.id || this.title;
    },
    isActive: {
      get() {
        return this.activeInternal;
      },
      set(value) {
        this.activeInternal = value;
        this.$emit(value ? 'opening' : 'closing');
        this.$emit('update:active', value);
      }
    }
  },
  data() {
    return {
      activeInternal: this.active
    };
  },
  methods: {
    toggle() {
      if (!this.multipleActive) {
        this.deactivateAll();
      }
      this.isActive = !this.isActive;
    }
  },
  watch: {
    active(newVal) {
      this.activeInternal = newVal;
    },
    shouldClose(val) {
      if (val) {
        this.isActive = false;
      }
    }
  },
  mounted() {
    if (!this.multipleActive) {
      this.deactivateAll();
    }
    this.addItem(this);
  },
  beforeDestroy() {
    this.removeItem(this);
  }
};
</script>

<style scoped>
  .collapse-item-header {
    display: flex;
    justify-content: start;
    align-items: center;
  }
</style>